module.exports = "<div ng-class=\"{ &quot;cui-required&quot;: input.cuiRequired, &quot;cui-invalid&quot;: input.cuiInvalid }\" ng-transclude=\"ng-transclude\" class=\"cui-input-wrapper\"></div>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/input-wrapper/template.jade
// module id = 822
// module chunks = 0